import { useCallback, useEffect, useState } from 'react';
import { CoverImageManager } from '@/lib/home/CoverImageManager';

export type UseCoverImageReturn = {
  coverImageUri: string | null;
  pickCoverImage: () => Promise<void>;
  removeCoverImage: () => Promise<void>;
  hasCoverImage: boolean;
};

/**
 * Hook for managing the home screen cover image.
 * Awaits CoverImageManager initialization before reading persisted URI.
 */
export function useCoverImage(): UseCoverImageReturn {
  const [coverImageUri, setCoverImageUri] = useState<string | null>(null);

  useEffect(() => {
    async function loadPersistedCoverImage() {
      const manager = CoverImageManager.getInstance();
      await manager.initialize();
      setCoverImageUri(manager.getCoverImageUri());
    }
    loadPersistedCoverImage();
  }, []);

  const pickCoverImage = useCallback(async () => {
    const manager = CoverImageManager.getInstance();
    const uri = await manager.pickImage();
    if (uri) {
      setCoverImageUri(uri);
    }
  }, []);

  const removeCoverImage = useCallback(async () => {
    const manager = CoverImageManager.getInstance();
    await manager.removeCoverImage();
    setCoverImageUri(null);
  }, []);

  return {
    coverImageUri,
    pickCoverImage,
    removeCoverImage,
    hasCoverImage: coverImageUri !== null,
  };
}
